export enum EGroupName {
	PASSENGER = 'passenger',
	VAN = 'van',
	AUTOMATIC = 'automatic',
	DELIVERY = 'delivery',
	SUV = 'suv',
	PREMIUM = 'premium',
	ELECTRIC = 'electric',
	COMBI = 'combi',
}

export enum EFuleTypeParameters {
	GASOLINE = 'Benzyna',
	HYBRID_GASOLINE_PLUG_IN = 'Benzyna hybrydowa typu plug-in (benzyna/elektro)',
	HYBRID_GASOLINE_PLUG_IN_2 = 'Plug-in hybrydowe benzyna ( benzyna / elektryczny )',
	DIESEL = 'Diesel',
	ELECTRIC = 'Elektryk',
	ELECTRIC_2 = 'Elektryczny',
	HYBRID = 'Hybrid (benzyna/elektryk)',
	HYBRID_2 = 'Hybrydowy (benzyna/elektryczny)',
}

export enum ETransmissionParameters {
	AUTOMATIC = 'Automatyczna',
	MANUAL = 'Manualna',
}

export const groupMap: { [key: string]: string } = {
	[EGroupName.PASSENGER]: 'Osobowe',
	[EGroupName.VAN]: 'VAN 7/9 os.',
	[EGroupName.AUTOMATIC]: 'Automat',
	[EGroupName.DELIVERY]: 'Dostawcze',
	[EGroupName.SUV]: 'SUV',
	[EGroupName.PREMIUM]: 'Premium',
	[EGroupName.ELECTRIC]: 'Elektryczne',
	[EGroupName.COMBI]: 'Kombi',
}

export const groupMapTranslations: { [key: string]: string } = {
	[EGroupName.PASSENGER]: 'passenger',
	[EGroupName.VAN]: 'van',
	[EGroupName.AUTOMATIC]: 'automatic',
	[EGroupName.DELIVERY]: 'delivery',
	[EGroupName.SUV]: 'suv',
	[EGroupName.PREMIUM]: 'premium',
	[EGroupName.ELECTRIC]: 'electric',
	[EGroupName.COMBI]: 'combi',
}

export const parametersMapTranslations: { [key: string]: string } = {
	[EFuleTypeParameters.GASOLINE]: 'gasoline',
	[EFuleTypeParameters.HYBRID_GASOLINE_PLUG_IN]: 'hybrid_gasoline_plug_in',
	[EFuleTypeParameters.HYBRID_GASOLINE_PLUG_IN_2]: 'hybrid_gasoline_plug_in',
	[EFuleTypeParameters.DIESEL]: 'diesel',
	[EFuleTypeParameters.ELECTRIC]: 'electric',
	[EFuleTypeParameters.ELECTRIC_2]: 'electric',
	[EFuleTypeParameters.HYBRID]: 'hybrid',
	[EFuleTypeParameters.HYBRID_2]: 'hybrid',
	[ETransmissionParameters.AUTOMATIC]: 'automatic',
	[ETransmissionParameters.MANUAL]: 'manual',
}
